(function () {
    'use strict';

    angular.module("imApp").factory("custactComplaintLineService", ['$ihttp', function ($ihttp) {
        var service = {
            getCustactComplaintLine: function (parms) {
                return $ihttp.post({
                    method: 2778,
                    parameters: parms || {}
                });
            },
            listSearchCauses: function (parms) {
                return $ihttp.post({
                    method: 2774,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2779,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();